import { EntityType } from "../entity/types.js";
export const PLAYER_GROUP_ID = 'player';
export var TargetType;
(function (TargetType) {
    TargetType[TargetType["SELF"] = 1] = "SELF";
    TargetType[TargetType["ALLIES"] = 2] = "ALLIES";
    TargetType[TargetType["ENEMIES"] = 4] = "ENEMIES";
})(TargetType || (TargetType = {}));
/**
 * The modifiers a timed combat effect can apply. Keyed rather than free-form so
 * `getActiveEffectTotal` can sum every source of the same modifier — a second
 * Stoneskin Potion, an enemy debuff, a future buff spell — without either side
 * knowing where the entry came from.
 */
export var ActiveCombatEffectKey;
(function (ActiveCombatEffectKey) {
    ActiveCombatEffectKey["TEMP_ARMOR"] = "temp_armor";
})(ActiveCombatEffectKey || (ActiveCombatEffectKey = {}));
/**
 * Returns true if this entity is directly controlled by the player (i.e. waits
 * for player input rather than taking an AI turn). Hirelings fight under AI
 * control even though they share the player's group.
 */
export function isPlayerControlled(entityState) {
    return entityState.groupId === PLAYER_GROUP_ID && entityState.entityType === EntityType.PLAYER;
}
